<template>
  <div class="app-store-container">
    <div class="app-store-content">
      <a href="https://apps.apple.com/us/app/acute-pro/id6744127101" target="_blank" rel="noopener noreferrer" class="app-store-link">
        <img src="acute-pro-icon.png" style="max-height: 128px;" />
        <img src="appstore-button.png" style="max-height: 64px;" />
      </a>
      <p class="app-store-message">You need the latest version of the <b>Acute Pro app for Apple Vision Pro</b> to play this video.</p>
    </div>
  </div>
</template>

<style scoped>
.app-store-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.app-store-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.app-store-link {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.app-store-message {
  font-size: 1rem;
  color: #4b5563;
  margin-top: 5px;
}
</style>
